<svelte:options runes={false} />
<script>
  // The capacity frontier (TASK-K2T-15): per symbol, the estimated max order notional under each
  // cost threshold — half the observed spread to cross plus a linear book-walk term anchored on
  // depth at touch. STRICTLY an estimate from the witness tape (the model is printed); a symbol
  // below the sample floor renders N/A, never an extrapolated curve.
  import { fmtBps, fmtCompactUsd } from '../../../lib/tca.js';
  import { displaySymbol as display } from '../../../lib/integrity.js';

  export let frontier = [];
</script>

{#if (frontier ?? []).length === 0}
  <div class="empty-state"><p class="empty-state-description">No tape-covered symbols yet.</p></div>
{:else}
  <div class="tca-scroll">
    <table>
      <thead>
        <tr>
          <th>Symbol</th><th class="num">Quotes</th><th class="num">Spread</th><th class="num">Depth @ touch</th>
          <th class="num">≤ 10 bps</th><th class="num">≤ 25 bps</th><th class="num">≤ 50 bps</th>
        </tr>
      </thead>
      <tbody>
        {#each frontier as f (f.symbol)}
          <tr>
            <td>{display(f.symbol)}</td>
            <td class="num">{f.samples}</td>
            {#if f.hasData}
              <td class="num">{fmtBps(f.medianSpreadBps).replace('+', '')} bps</td>
              <td class="num">{fmtCompactUsd(f.medianDepthQuote)}</td>
              <td class="num">{fmtCompactUsd(f.maxNotionalAt10Bps)}</td>
              <td class="num">{fmtCompactUsd(f.maxNotionalAt25Bps)}</td>
              <td class="num">{fmtCompactUsd(f.maxNotionalAt50Bps)}</td>
            {:else}
              <td class="num tca-na" colspan="5">insufficient tape — N/A</td>
            {/if}
          </tr>
        {/each}
      </tbody>
    </table>
  </div>
  <p class="tca-note">est. cost(N) ≈ spread/2 + spread · N / depth$ (median spread + depth over the most recent tape — up to 500 quotes within the trailing 24h) — an estimate, not engine parity.</p>
{/if}

<style>
  .tca-scroll { overflow-x: auto; }
  table { width: 100%; border-collapse: collapse; font-size: 0.72rem; }
  th, td { padding: 0.3rem 0.45rem; border-bottom: 1px solid var(--border-subtle, #1e1f22); white-space: nowrap; text-align: left; }
  th { font-size: 0.64rem; text-transform: uppercase; letter-spacing: 0.05em; color: var(--text-muted, #8a8b8d); }
  th.num, td.num { text-align: right; font-variant-numeric: tabular-nums; }
  .tca-na { color: var(--text-muted, #8a8b8d); font-style: italic; text-align: left; }
  .tca-note { margin: 0.4rem 0 0; font-size: 0.64rem; color: var(--text-muted, #8a8b8d); }
</style>
